export default "__VITE_ASSET__BphyoSHV__"